import { t } from '@lingui/core/macro';
import { AddressRecord } from '@navio/nsdk';
import { NoddiBasicCard, NoddiInfoBanner, useIsMobile, useScrollIntoView } from 'noddi-ui-web';
import { useState } from 'react';

import { NoServiceOfferedForm } from './NoServiceOfferedForm';

type SelectedAddressDetailsProps = {
  address: AddressRecord;
  translations: {
    noServiceOfferedNotice: string;
  };
};

export const NoServiceOffered = ({ translations, address }: SelectedAddressDetailsProps) => {
  const isMobile = useIsMobile();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const containerRef = useScrollIntoView(!!address && isMobile);

  if (isFormSubmitted) {
    return <NoddiInfoBanner variant='success' texts={[{ value: t`Thank you! We’ll Keep You Updated` }]} />;
  }
  return (
    <div ref={containerRef}>
      <NoddiBasicCard className='flex flex-col gap-4'>
        {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
        <div>{translations.noServiceOfferedNotice} 😔</div>

        <NoServiceOfferedForm address={address} setIsFormSubmitted={setIsFormSubmitted} />
      </NoddiBasicCard>
    </div>
  );
};
